/* SB Diamonds storefront navigation. Uses native collection/tag URLs so filters
   and sorting apply across the entire catalog. Recognized legacy preview links
   redirect to real collections. Customer inquiry text is never logged or stored. */
(() => {
  'use strict';
  const params = new URLSearchParams(window.location.search);
  const category = document.querySelector('#category-filter');
  const stone = document.querySelector('#stone-filter');
  const sort = document.querySelector('#sort-filter');
  const categories = ['all', 'necklaces', 'pendants', 'bracelets', 'rings', 'earrings'];
  // Build only known same-origin routes; query text cannot inject markup or URLs.
  const collectionUrl = (categoryValue, stoneValue, sortValue) => {
    const handle = categories.includes(categoryValue) ? categoryValue : 'all';
    const tag = { natural: '/natural-diamond', lab: '/lab-diamond' }[stoneValue] || '';
    const url = new URL('/collections/' + handle + tag, window.location.origin);
    if (sortValue) url.searchParams.set('sort_by', sortValue);
    return url;
  };
  if (params.get('view') === 'catalog') {
    const requested = params.get('category');
    const legacyCategory = requested === 'chains' ? 'necklaces' : requested;
    const legacyStone = requested === 'lab-diamonds' ? 'lab' : params.get('stone');
    window.location.replace(collectionUrl(legacyCategory, legacyStone, ''));
    return;
  }
  // Shopify renders the selected state; changing a filter resets pagination.
  if (category && stone && sort) {
    [category, stone, sort].forEach((field) => field.addEventListener('change', () => {
      window.location.assign(collectionUrl(category.value, stone.value, sort.value));
    }));
  }
  // Keep one category and one material panel open, and dismiss with Escape or
  // an outside click. Native details still work when scripts are unavailable.
  const menus = [...document.querySelectorAll('.nav-tree, .nav-branch')];
  menus.forEach((menu) => menu.addEventListener('toggle', () => {
    if (!menu.open) return;
    menus.forEach((other) => {
      if (other !== menu && other.parentElement === menu.parentElement) other.open = false;
    });
  }));
  document.addEventListener('click', (event) => {
    menus.forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const current = document.activeElement?.closest('.nav-branch, .nav-tree');
    if (current) { current.open = false; current.querySelector('summary').focus(); }
    else menus.forEach((menu) => { menu.open = false; });
  });
  const message = document.querySelector('#message');
  if (message && params.get('piece')) {
    message.value = 'I am interested in a piece inspired by the ' + params.get('piece').slice(0, 120) + '.\n\nMy preferred details: ';
  }
})();
